import { Globe } from 'lucide-react';
import { CartaoDoNo, EntradaDoNo, SaidaPadrao } from './node-chrome';

export default function WebhookNode({ data }: any) {
  return (
    <>
      <EntradaDoNo />
      <CartaoDoNo
        tipo="webhook_request"
        dados={data}
        icone={Globe}
        corDoTopo="bg-rose-500"
        corDoIcone="text-rose-600"
        titulo={data.label || 'Enviar para outro sistema'}
      >
        {data.saveResponseTo && (
          <div className="mt-2 text-[10px] text-muted-foreground truncate">
            Guarda a resposta em {data.saveResponseTo}
          </div>
        )}
      </CartaoDoNo>
      <SaidaPadrao />
    </>
  );
}
